<template>
  <BaseDialog isOpen>
    <template v-slot:title>
      <div>
        Are you sure you want to reset the password of
        <span> {{ user | fullName }}</span>
        ?
      </div>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="close" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Reset Password
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { RESET_USER_PASSWORD } from "@/store/modules/users/actions";

const { mapActions } = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  name: "ResetPasswordDialog",
  components: { PrimaryButton, BaseDialog },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions({
      resetPassword: RESET_USER_PASSWORD
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.resetPassword(this.user.id);
      this.close();
      this.$emit("reset");
      this.isLoading = false;
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
